import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import PropTypes from 'prop-types';
import React from 'react';
import logo from '../../assest/img/logo-gojapan.png';
import Languages from '../Languages';

TopNavBar.propTypes = {
    onMenuClick: PropTypes.func,
};
TopNavBar.defaultTypes = {
    onMenuClick: null,
};

function TopNavBar({ onMenuClick }) {
    const handleMenuClick = (menu) => {
        if (!onMenuClick) return;
        onMenuClick(menu);
    };
    return (
        <Box sx={{ bgcolor: '#fffff' }}>
            <Container
                maxWidth="xl"
                sx={{
                    '@media (max-width: 640px)': {
                        paddingX: 0,
                    },
                }}
            >
                <AppBar position="static" sx={{ boxShadow: 'none' }}>
                    <Toolbar
                        sx={{
                            bgcolor: '#ffffff',
                            paddingLeft: '0 !important',
                            '@media screen and (max-width: 767px)': {
                                justifyContent: 'center',
                                paddingLeft: '16px !important',
                            },
                        }}
                    >
                        <Box
                            component="img"
                            sx={{
                                height: 'auto',
                                width: '100%',
                                maxWidth: 150,
                                '@media (max-width: 640px)': {
                                    maxWidth: 130,
                                },
                            }}
                            alt="Go Japana Mobile"
                            src={logo}
                        />
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                width: '100%',
                                height: '40px',
                                '@media (max-width: 640px)': {
                                    height: '30px',
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    width: 80,
                                    '@media screen and (max-width: 768px)': {
                                        // display: 'none',
                                    },
                                }}
                            >
                                <Languages />
                            </Box>

                            {/* <Button
                                onClick={() => handleMenuClick(true)}
                                sx={{
                                    color: '#ffff',
                                    '@media screen and (min-width: 876px)': {
                                        display: 'none',
                                    },
                                }}
                            >
                                <MenuIcon />
                            </Button> */}
                        </Box>
                    </Toolbar>
                </AppBar>
            </Container>
        </Box>
    );
}

export default TopNavBar;
